<template>
  <div class="checkbox">
    <label :for="`checkbox${index}`" class="checkbox_label">
      <a
        :href="builtQueryString"
        :title="variation.variationName"
        class="active"
      >
        <span>{{ variation.variationName }}</span>
        <i class="lni lni-close"></i>
      </a>
    </label>
  </div>
</template>

<script>
import VariationListingFiltersModel from './variations/filters/Models/VariationListingFiltersModel'
import { mapGetters } from 'vuex'

export default {
  name: 'AdvListingUsedVariation',
  props: {
    group: {
      variationDisplayType: '',
      variationGroupId: '',
      variationGroupName: null,
      variationGroupStep: 0,
      variationGroupDisplayPosition: 0,
      variations: []
    },
    variation: {
      variationDisplayValue: '',
      variationId: '',
      variationName: '',
      variationOrder: ''
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'getUriWithoutOffset',
      'getVariationFilterQueryStringVar',
      'getActiveVariationFilters',
      'getIsTopLevelCategory',
      'getCurrentPageNumber',
      'getActiveAttributeFiltersString',
      'getActiveTagFiltersString',
      'config'
    ]),
    builtQueryString () {
      return this.filteringManage(this.group, this.variation)
    },
    activeFiltersString () {
      const tagFiltersString = this.getActiveTagFiltersString
      const attributeFiltersString = this.getActiveAttributeFiltersString
      if (tagFiltersString !== '' && attributeFiltersString !== '') {
        return tagFiltersString + '&' + attributeFiltersString
      }
      if (tagFiltersString !== '') {
        return tagFiltersString
      }
      if (attributeFiltersString !== '') {
        return attributeFiltersString
      }
      return ''
    }
  },
  methods: {
    filteringManage (group, entry) {
      const isFilterUsed = true
      const duplicateVariationGroupNamesPerGroup = {}
      return new VariationListingFiltersModel(
        this.getUriWithoutOffset,
        this.getVariationFilterQueryStringVar,
        this.getActiveVariationFilters,
        this.getIsTopLevelCategory,
        this.getCurrentPageNumber,
        this.config.url.lang,
        this.activeFiltersString,
        duplicateVariationGroupNamesPerGroup
      ).createLinkQueryStringFinal(group, entry, isFilterUsed)
    }
  }
}

</script>

<style lang="scss" scoped>
.prod_list_header_filters {
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  margin-bottom: 45px;
}
.checkbox {
  position: relative;
  width: 100%;
  display: grid;
  margin: 0;
  border: 1px solid black;
  border-radius: 8px;
  font-size: 12px;
  padding: 0 10px;
  line-height: 1.2;
  font-weight: 500;
  height: 40px;
  .checkbox_label {
    display: flex;
    padding: 0 10px;
    cursor: pointer;
    color: black;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    height: 100%;
    align-items: center;
    align-content: center;
    margin: 0;
    &:before{
      display: none
    }
    a {
      display: grid;
      gap: 5px;
      grid-template-columns: 1fr auto;
      align-items: center;
      i {
        color: var(--prime2);
      }
    }
  }
  .checkbox_input:checked+.checkbox_label::before {
    display: none
  }
}
.native_slider-lg {
  border-right: 1px solid #707070;
}
</style>
